import clsx from 'clsx';

type ContainerProps = React.PropsWithChildren<{
	fit?: boolean;
	full?: boolean;
	className?: string;
}>;

export function Container({ fit, full, className, ...props }: ContainerProps) {
	return (
		<div
			className={clsx(
				{ 'md:max-w-full': full },
				{ 'md:max-w-[642px]': fit },
				{ 'md:max-w-[1344px]': !full && !fit },
				'mx-auto w-full px-4',
				className,
			)}
			{...props}
		/>
	);
}
